<div class="single-advertiser layout-spacing">
    <div class="single-advertiser-con">
        <div class="single-advertiser__contents contents">
            <div class="contents__header">
                <ntv-card variant="elevated" rounded="xl" shadow="md">
                    <div class="advertiser-card">
                        <div class="details__image">
                            <img [src]="advertiserData.image" alt="Host Image" />
                        </div>
                        <div class="details__info">
                            <div class="details__info-title">
                                <h3>{{ advertiserData.name.value }}</h3>

                                <div class="advertiser-btn">
                                    <ntv-button
                                        variant="outline"
                                        rounded="md"
                                        variant="primary"
                                        size="xl">
                                        <div class="main-btn">
                                            Modify

                                            <svg width="14" height="14">
                                                <use
                                                    [attr.href]="
                                                        spritePath + '#' + icons['tv']
                                                    "></use>
                                            </svg>
                                        </div>
                                    </ntv-button>
                                </div>
                            </div>
                            <div class="details__info-status"></div>
                            <div class="details__info-data">
                                <div class="data-left">
                                    @for (item of advertiserData.dealerInfo; track $index) {
                                        <div class="data-info">
                                            <p class="label">{{ item.label }}</p>
                                            <span class="value">{{ item.value }}</span>
                                        </div>
                                    }
                                </div>

                                <div class="data-right">
                                    <div class="data-tags">
                                        <p class="label">TAGS</p>
                                        <div class="data-info-tags">
                                            @for (item of tags; track $index) {
                                                <span
                                                    class="value-tag"
                                                    [style.backgroundColor]="item.color"
                                                    >{{ item.label }}</span
                                                >
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ntv-card>
            </div>
            <div class="contents__gallery">
                <ntv-card variant="elevated" rounded="xl" shadow="md">
                    <div class="contents__gallery-toolbar">
                        <div class="toolbar__title-group">
                            <h4 class="toolbar__title">Advertiser Contents</h4>
                            <span class="toolbar__subtitle">All contents (10)</span>
                        </div>
                        <div class="toolbar__main">
                            <div class="toolbar__left">
                                <ntv-button variant="accent" size="xl">
                                    <div class="flex items-center gap-2">
                                        <svg width="14" height="14">
                                            <use
                                                [attr.href]="spritePath + '#' + icons.filter"></use>
                                        </svg>
                                        <span>Filter by</span>
                                    </div>
                                </ntv-button>
                            </div>

                            <div class="toolbar__right">
                                <div class="toolbar__search">
                                    <ntv-input placeholder="Search Advertiser Content" size="md">
                                        <div prefix>
                                            <svg width="14" height="14">
                                                <use
                                                    [attr.href]="
                                                        spritePath + '#' + icons.search
                                                    "></use>
                                            </svg>
                                        </div>
                                    </ntv-input>
                                </div>

                                <div class="toolbar__view-toggles">
                                    <div
                                        class="view-toggle"
                                        [class.view-toggle--active]="currentView() === 'grid'"
                                        (click)="setView('grid')">
                                        <svg width="40" height="40">
                                            <use
                                                [attr.href]="
                                                    spritePath + '#' + icons.gridView
                                                "></use>
                                        </svg>
                                    </div>
                                    <div
                                        class="view-toggle"
                                        [class.view-toggle--active]="currentView() === 'list'"
                                        (click)="setView('list')">
                                        <svg width="40" height="40">
                                            <use
                                                [attr.href]="
                                                    spritePath + '#' + icons.listView
                                                "></use>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ntv-card>

                <ntv-card variant="elevated" rounded="xl" shadow="md">
                    @if (currentView() === 'grid') {
                        <div class="contents__gallery-grid">
                            @for (item of galleryItems; track item.id) {
                                <ntv-thumbnail-item
                                    [disableRightClick]="true"
                                    [item]="$any(item)"
                                    [showFavoriteIcon]="true"
                                    [menuOptionVisible]="true"
                                    [selectable]="true"
                                    [clickable]="true"
                                    size="sm"
                                    (itemClicked)="onItemClicked($event)"></ntv-thumbnail-item>
                            }
                        </div>
                    } @else {
                        <div class="contents__gallery-list">
                            <app-table
                                [columns]="tableColumns"
                                [data]="galleryItems"
                                [hasCheckBox]="false"
                                [showColumnSettings]="false"
                                tableHeight="600px"
                                (cellClick)="onCellClicked($event)"></app-table>
                        </div>
                    }
                </ntv-card>
            </div>
        </div>
        <div class="single-advertiser__overview">
            <ntv-card variant="elevated" rounded="xl" shadow="md">
                <div class="content-overview">
                    <div class="overview__header">
                        <div class="overview__icon">
                            <svg width="14" height="14">
                                <use [attr.href]="spritePath + '#' + icons.mediaLibrary"></use>
                            </svg>
                        </div>
                        <h4 class="overview__title">Content Overview</h4>
                    </div>

                    <div class="overview__preview">
                        <ntv-thumbnail-preview
                            size="xl"
                            [thumbnailSrc]="selectedItem().thumbnail"
                            [fileName]="selectedItem().name"
                            [clickable]="false"
                            [hoverEffects]="false">
                            <div slot="details" class="overview__details">
                                <div class="details__title">
                                    <h4>{{ selectedItem().name }}</h4>
                                    <svg
                                        width="14"
                                        height="14"
                                        class="text-accent-main cursor-pointer">
                                        <use [attr.href]="spritePath + '#' + 'new-tab'"></use>
                                    </svg>
                                </div>

                                <div class="details__info-group">
                                    <p class="section-title">Content Details</p>
                                    <div class="info-list">
                                        @for (detail of itemDetails(); track detail.label) {
                                            <div class="info-item">
                                                <span class="label">{{ detail.label }}</span>
                                                <span class="value">{{ detail.value }}</span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </ntv-thumbnail-preview>
                    </div>

                    <div class="single-advertiser__tabs">
                        <ntv-tabs
                            [tabs]="tabs"
                            [activeIndex]="activeTab()"
                            (tabChange)="onTabChange($event)"></ntv-tabs>

                        <div class="tab-content-container">
                            <!-- Dealer Info Tab Content -->
                            @if (activeTab() === 0) {
                                <div class="tab-content">
                                    <app-dealer-info />
                                </div>
                            }

                            <!-- Host Location Tab Content -->
                            @if (activeTab() === 1) {
                                <div class="tab-content">
                                    <app-host-location />
                                </div>
                            }

                            <!-- Playlist Tab Content -->
                            @if (activeTab() === 2) {
                                <div class="tab-content">
                                    <app-playlist />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </ntv-card>
        </div>
    </div>
</div>
